<template>
  <wrapper>
    <main class="main-content-wrapper">
      <card>
        <div class="row">
        <div class="col-lg-3">
          Product Type
          <multiselect
            v-model="searchType"
            :options="getCatalogListType()"
            label="statusName"
            :allow-empty="false"
            :select-label="'Type'"
            :deselect-label="''"
            placeholder="Select Product Type"
            track-by="statusName"
          ></multiselect>
        </div>
        <div class="col-lg-3">
          Product Category
          <multiselect
            v-model="searchCategory"
            :options="getCatalogListCategory()"
            label="statusName"
            :allow-empty="false"
            :select-label="'Type'"
            :deselect-label="''"
            placeholder="Select Product Category"
            track-by="statusName"
          ></multiselect>
        </div>
        <div class="col-lg-3">
          Product Name
          <input
            type="text"
            name=""
            class="form-control"
            placeholder="Product Name"
            v-model="searchProductName"
          />
        </div>
        <div class="col-lg-3">
          Product Status
          <multiselect
            v-model="searchStatus"
            :options="$getConstants('CATALOG_STATUS', 'all')"
            label="statusName"
            :allow-empty="false"
            :select-label="'Type'"
            :deselect-label="''"
            placeholder="Select Product Status"
            track-by="statusName"
          ></multiselect>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-4">
        <div>
          <button
            class="btn btn-primary default-btn"
            @click="searchData(1)"
          >
            Search
          </button>
        </div>
        <div>
          <button
            class="btn reset-btn default-btn ml-2"
            @click="resetSearch()"
          >
            Reset
          </button>
        </div>
      </div>
      </card>
      <div class="mt-4">
        <modal-option-add-product/>
      </div>
      <br />
      <table
        class="table table-sm table-bordered table-striped table-responsive-sm"
      >
        <thead class="">
          <tr>
            <th style="text-align: center;">ID</th>
            <!-- <th>Type</th> -->
            <!-- <th>Category</th> -->
            <th style="text-align: center;">Product Name</th>
            <!-- <th>Catalog Type</th> -->
            <th style="text-align: center;">Status</th>
            <th style="text-align: center; width: 110px">Show Order</th>
            <th style="text-align: center; width: 150px">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="loadingTable === false && totalData == '0'">
            <td colspan="9" class="text-center">Data Not Available</td>
          </tr>
          <tr v-else-if="loadingTable === true">
            <td colspan="9" class="text-center">
              <img src="~@/assets/images/load-button.gif" />
            </td>
          </tr>
          <tr
            v-for="(data, index) in dataCatalog"
            v-else
            :key="`catalog-${index}`"
          >
            <td>{{ data.catalogId }}</td>
            <!-- <td>{{ data.catalogTypeName }}</td> -->
            <!-- <td>{{ data.catalogCategory }}</td> -->
            <td>
              <div>{{ data.catalogTypeName }} {{ data.catalogTitle }}</div>
              <div>{{ data.catalogSpecifications }}</div>
            </td>
            <!-- <td>{{ $getConstantsName('CATALOG_TYPE',parseInt(data.totalProduct)>1?1:0) }}</td> -->
            <td>
              <label class="badge badge-danger" v-if="data.catalogStatus == '0'"
                >Inactive</label
              >
              <label
                class="badge badge-success"
                v-if="data.catalogStatus == '1'"
                >Active</label
              >
            </td>
            <td>{{ data.catalogShowingOrder }}</td>
            <td>
              <div class="d-flex justify-content-center" style="gap: 5px">
                <button
                  class="btn icon-btn icon-btn-blue"
                  @click="getCatalogSetting(data)"
                  v-if="data.topProduct == null && data.catalogStatus != '0'"
                >
                  <img src="~@/assets/icon/eye-blue.svg" alt="eye icon">
                </button>
                <button class="btn icon-btn icon-btn-orange" @click="toEditForm(data)">
                  <img src="~@/assets/icon/pencil-edit-orange.svg" alt="pencil edit icon">
                </button>
                <button
                  class="btn icon-btn icon-btn-red"
                  v-if="data.catalogStatus == 1"
                  @click="openModalChange(data)"
                >
                  <img src="~@/assets/icon/forbidden-red.svg" alt="forbidden icon">
                </button>
                <button
                  class="btn icon-btn icon-btn-green"
                  v-if="data.catalogStatus != 1"
                  @click="openModalChange(data)"
                >
                  <img src="~@/assets/icon/rollback-green.svg" alt="pencil edit icon">
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-between">
        <div class="d-flex">
          <div style="margin-right: 10px">
            <select
              class="form-control form-control-sm"
              v-model="itemPerPage"
              @change="searchData(currentPage)"
            >
              <option value="10">10</option>
              <option value="40">40</option>
              <option value="80">80</option>
            </select>
          </div>
          <div class="total-data align-self-center">
            Total Data {{ totalData }}
          </div>
        </div>
        <div>
          <div class="pagination p8 alignRight">
            <ul>
              <a
                class="is-active link"
                @click="searchData(parseInt(currentPage) - 1)"
                v-if="currentPage != 1"
              >
                <li>
                  {{ "<" }}
                </li>
              </a>
              <a class="page">
                <li>{{ currentPage }} of {{ totalPage }} page</li>
              </a>
              <a
                class="is-active link"
                @click="searchData(parseInt(currentPage) + 1)"
                v-if="currentPage != totalPage"
              >
                <li>{{ ">" }}</li>
              </a>
            </ul>
          </div>
        </div>
      </div>
    </main>
    <!-- /#page-content-wrapper -->
    <div class="modal fade" id="modalShowSetting" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Show Settings</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <label>Top Product Setting :</label>
            <div class="d-flex">
              <label class="ml-4 field-label">Top Product</label>
              <div class="w-100">
                <input
                  type="radio"
                  v-model="showTop"
                  value="yes"
                  class="link ml-2"
                />
                <label>Yes</label>
                <input
                  type="radio"
                  v-model="showTop"
                  value="no"
                  class="link ml-2"
                />
                <label>No</label>
              </div>
            </div>
            <div
              class="d-flex align-items-center"
              v-if="topProducts.length >= 4 && showTop == 'yes'"
            >
              <span class="ml-4 field-label">Replacing</span>
              <multiselect
                v-model="showReplace"
                :options="topProducts"
                label="catalogTitle"
                :allow-empty="false"
                :select-label="'Name'"
                :deselect-label="''"
                placeholder="Catalog Name"
                track-by="catalogTitle"
              ></multiselect>
            </div>
            <label class="mt-4">Showing Order Setting :</label>
            <div class="d-flex align-items-center">
              <span class="ml-4 field-label">Show Order</span>
              <multiselect
                v-model="showOrder"
                :options="showingOrders"
                label="catalogShowingOrder"
                :allow-empty="false"
                :select-label="'Show Order'"
                :deselect-label="''"
                placeholder="Catalog Show Order"
                track-by="catalogShowingOrder"
              ></multiselect>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn-sm"
              :disabled="loadingButtonNext"
              @click="changeCatalogSetting()"
            >
              <img
                src="~@/assets/images/2.gif"
                style="height: 18px; margin-right: 1px"
                v-if="loadingButtonNext"
              />Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- mudalChangeStatus -->
    <div class="modal fade" id="modalChange" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Change Status</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <p>
              Are you sure want to set {{ selectedCatalog.catalogTitle }}
              {{
                $getConstantsName(
                  "CATALOG_STATUS",
                  selectedCatalog.catalogStatus == 1 ? 0 : 1
                ).toLowerCase()
              }}?
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              v-if="loadingButtonProcess == false"
              @click="submitChangeStatus"
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-else
            >
              <img
                src="~@/assets/images/2.gif"
                style="height: 18px; margin-right: 1px"
              />Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- endModal -->
  </wrapper>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import SideBar from "../SideBar";
import { Wrapper, LoadingScreen, Card } from "../Layout";
import CONSTANT from "../constPlugin";
import ModalOptionAddProduct from "./Components/ModalOptionAddProduct.vue";

export default {
  name: "ProductPage",
  components: {
    SideBar,
    Multiselect,
    Wrapper,
    Card,
    ModalOptionAddProduct,
  },
  data() {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      dataCatalog: [],
      searchType: {
        status: "All",
        statusName: "All",
      },
      searchStatus: {
        status: "All",
        statusName: "All",
      },
      searchProductName: "",
      searchCategory: {
        status: "All",
        statusName: "All",
      },
      searchBundling: "",
      admin: "",
      adminId: "",
      selectedCatalog: "",
      showTop: "",
      showReplace: "",
      showOrder: {},
      topProducts: [],
      showingOrders: [],
      catalogPropertyType: [],
      catalogPropertyCategory: [],

      permission: [],
      viewDashboard: false,
      viewOrder: false,
      viewReturn: false,
      viewProduct: false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewLessee: false,
      viewEmployee: false,
      editOrder: false,
      editReturn: false,
      editProduct: false,
      editPairing: false,
      editReconcile: false,
      editResolution: false,
      editLessor: false,
      editLessee: false,
      editEmployee: false,
      loadingButtonProcess: false,
      loadingButtonNext: false,
      dataProduct: [],
      dataSearchProduct: [],
      totalPage: 0,
      totalData: 0,
      currentPage: 1,
      orderId: "",
      companyName: "",
      statusOrder: "",
      loadingTable: true,
      productBrand: [],
      productBrandSearch: [],
      productSpec: [],
      productIdChoose: "",
      productNameChoose: "",
      statusChoose: "",
      productCategory: [],
      productType: [],
      brandSelect: [],
      allShowing: [],
      categoryShowing: [],
      showingChoose: "",
      typeChoose: "",
      itemPerPage: 10,
      productStatusSelect: [
        {
          status: "All",
          statusName: "All",
        },
        {
          status: "1",
          statusName: "Active",
        },
        {
          status: "0",
          statusName: "Inactive",
        },
      ],
      productTypeAdd: "unit",
    };
  },
  methods: {
    getCatalogListType() {
      return this.$getConstantsFromList(this.catalogPropertyType, "all");
    },
    getCatalogListCategory() {
      return this.$getConstantsFromList(this.catalogPropertyCategory, "all");
    },
    nextAdd(page) {
      this.loadingButtonNext = true;
      if (page.toLowerCase() == "unit") {
        this.toFormPage("Add", 1, 0);
      } else if (page.toLowerCase() == "bundling") {
        this.toFormPage("Add", 0, 0);
      }
    },
    toEditForm(data) {
      this.loadingButtonNext = true;
      if (data.totalProduct == 1) {
        this.toFormPage("Edit", 1, data.catalogId);
      } else {
        this.toFormPage("Edit", 0, data.catalogId);
      }
    },
    toFormPage(addORedit, unit, id) {
      this.$router.push({
        path: "/catalog/edit/" + id,
        query: {
          unit: unit,
        }
      });
      // this.$router.push({
      //   path: "/catalog/form",
      //   query: {
      //     f: addORedit,
      //     unit: unit,
      //     catalogId: id,
      //   },
      // });
    },
    toProductEditPage(productId, typeProduct) {
      this.$router.push({
        path: "/product/edit/" + typeProduct,
        query: {
          productId: productId,
        },
      });
    },
    resetSearch() {
      this.searchType = { status: "All", statusName: "All" };
      this.searchCategory = { status: "All", statusName: "All" };
      this.searchProductName = "";
      this.searchStatus = { status: "All", statusName: "All" };
      this.searchBundling = { status: "All", statusName: "All" };
      this.currentPage = 1;
      this.itemPerPage = 10;
      this.searchData(1);
    },
    submitTopProduct() {
      this.loadingButtonProcess = true;
      this.$http
        .post(
          process.env.ADD_TOP_PRODUCT,
          {
            productId: this.productIdChoose,
            adminId: this.adminId,
          },
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            });
          } else if (response.data.status == 200) {
            swal("Success", response.data.message, "success", {
              button: "Ok",
            });
            $("#modalToTop").modal("hide");
            this.sendLog(this.productIdChoose, 31);
            this.getData();
            this.loadingButtonProcess = false;
          }
        })
        .catch((error) => {
          swal("Sorry", error.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });
    },
    openModalShow(data) {
      this.selectedCatalog = data;
      if (data.topCatalog != null) {
        this.showTop = "yes";
        // this.showReplace= data
      } else this.showTop = "no";
      this.showReplace = this.getShowReplace(data.catalogId);
      this.showOrder = this.getShowOrder(data.catalogShowingOrder);
      $("#modalShowSetting").modal("show");
    },
    openModalChange(data) {
      this.selectedCatalog = data;
      $("#modalChange").modal("show");
    },
    getShowReplace(catalogId) {
      for (var i = 0; i < this.topProducts.length; i++) {
        if (this.topProducts[i].catalogId == catalogId) {
          return this.topProducts[i];
        }
      }
      return null;
    },
    getShowOrder(showOrder) {
      for (var i = 0; i < this.showingOrders.length; i++) {
        if (this.showingOrders[i].catalogShowingOrder == showOrder) {
          return this.showingOrders[i];
        }
      }
      return null;
    },
    openModalAdd() {
      $("#modalAdd").modal("show");
    },
    openModalEdit(data) {
      this.selectedCatalog = data;
    },
    openModalStatus(data) {
      this.selectedCatalog = data;
      $("#modalChange").modal("show");
    },
    openModal(x, y, z, a, b, c, d) {
      this.productIdChoose = y;
      this.statusChoose = z;
      this.productNameChoose = a;
      console.log(x);
      if (x == "ToTop") {
        this.productNameChoose = z;
      } else if (x == "Change") {
        for (var i = 0; i < this.allShowing.length; i++) {
          if (this.allShowing[i]["type"] == b) {
            this.categoryShowing = this.allShowing[i]["showingOrder"];
          }
        }
        this.showingChoose = c;
        this.typeChoose = b;
      }

      $("#modal" + x).modal("show");
    },
    searchData(pagePost) {
      if (this.searchType == null) {
        this.searchType = { status: "All", statusName: "All" };
      }
      this.$goToCatalogProduct(
        this.$router,
        this.searchType.status,
        this.searchProductName,
        this.searchCategory.status,
        this.searchStatus.status,
        1,
        this.itemPerPage,
        pagePost,
        this.searchType.statusName,
        this.searchCategory.statusName
      );
    },
    getCatalogSetting(data) {
      this.$http
        .post(
          process.env.GET_CATALOG_SETTING,
          {
            catalogCategory: data.catalogCategory,
          },
          {
            timeout: 300 * 1000,
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            });
            // this.handleLogout();
          } else if (response.data.status == 200) {
            this.topProducts = response.data.content.topProducts;
            this.showingOrders = response.data.content.showingOrder;
            this.openModalShow(data);
          } else {
            swal("Failed", response.data.message, "error", {
              button: "Close",
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.loadingButtonProcess = false;
          // Timeout atau masalah jaringan
          if (error.code === "ECONNABORTED") {
            alert("Request timeout: Server terlalu lama merespons.");
            return;
          }

          if (!error.response) {
            swal("Error", "Tidak ada respons dari server.", "error");
            return;
          }

          const status = error.response.data.status;
          const message = error.response.data.message || "Terjadi kesalahan";
          alert("Request timeout / error with api, please try again!");

          swal("Sorry", message, "error", {
            button: "Ok",
          }).then(() => {
            if (status === 401) {
              this.handleLogout();
            }
          });
        });
    },
    changeCatalogSetting() {
      var data = this.selectedCatalog;
      var afterTop = this.topProducts.length + 1;
      var catalogIdTopReplace = 0;
      if (this.topProducts.length == 4 && this.showTop == "yes") {
        afterTop = this.showReplace.topCatalog;
        catalogIdTopReplace = this.showReplace.catalogId;
      }
      this.$http
        .post(
          process.env.CHANGE_CATALOG_SETTING,
          {
            catalogId: Number(data.catalogId),
            catalogCategory: data.catalogCategory,
            catalogIdShowReplace: this.showOrder.catalogId,
            beforeShowOrder: data.catalogShowingOrder,
            afterShowOrder: this.showOrder.catalogShowingOrder,
            catalogIdTopReplace: catalogIdTopReplace,
            beforeTop: data.topCatalog,
            afterTop: afterTop,
            changeTop: this.showTop,
            adminId: this.adminId,
          },
          {
            timeout: 300 * 1000,
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            });
            // this.handleLogout();
          } else if (response.data.status == 200) {
            swal("Success", response.data.message, "success", {
              button: "Ok",
            });
            this.getData();
            $("#modalShowSetting").modal("hide");
          } else {
            swal("Failed", response.data.message, "error", {
              button: "Close",
            });
          }
        })
        .catch((error) => {
          alert("Request timeout / error with api, please try again!");
          this.loadingButtonProcess = false;
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });
    },
    toPage(e) {
      this.$router.push(e);
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(
          process.env.LOGOUT,
          {},
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        );
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          });
          return;
        }
      } catch (error) {
        if (error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          });
          return;
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem("changeCatalogPermission");
      this.$router.push("/");
    },
    cekLogin() {
      if (localStorage.getItem("jwt") == null) {
        this.$router.push("/");
      }
    },
    cekPermission() {
      this.permission = localStorage
        .getItem("roles")
        .replace(/"/g, "")
        .replace("[", "")
        .replace("]", "")
        .split(",");
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == "1") {
          this.viewDashboard = true;
        }
        if (this.permission[i] == "2.1") {
          this.viewOrder = true;
        }
        if (this.permission[i] == "2.2") {
          this.editOrder = true;
        }
        if (this.permission[i] == "3.1") {
          this.viewReturn = true;
        }
        if (this.permission[i] == "3.2") {
          this.editReturn = true;
        }
        if (this.permission[i] == "4.1") {
          this.viewProduct = true;
        }
        if (this.permission[i] == "4.2") {
          this.editProduct = true;
        }
        if (this.permission[i] == "5.1") {
          this.viewPairing = true;
        }
        if (this.permission[i] == "5.2") {
          this.editPairing = true;
        }
        if (this.permission[i] == "6") {
          this.viewReconcile = true;
        }
        if (this.permission[i] == "7.1") {
          this.viewResolution = true;
        }
        if (this.permission[i] == "7.2") {
          this.editResolution = true;
        }
        if (this.permission[i] == "8.1") {
          this.viewLessor = true;
        }
        if (this.permission[i] == "8.2") {
          this.editLessor = true;
        }
        if (this.permission[i] == "9.1") {
          this.viewLessee = true;
        }
        if (this.permission[i] == "9.2") {
          this.editLessee = true;
        }
        if (this.permission[i] == "10") {
          this.viewEmployee = true;
        }
      }
      if (this.viewProduct == false) {
        this.$router.push("/");
      }
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    toDetail(id) {
      this.$router.push("/product/detail/" + id);
    },
    async getData() {
      try {
        this.loadingTable = true;
        this.searchStatus = this.$getConstantsObjectS(
          "CATALOG_STATUS",
          this.$route.query.status
        );
        this.searchProductName = this.$route.query.name;
        this.searchType.status = this.$route.query.type;
        this.searchType.statusName = this.$route.query.typeName;
        this.searchCategory.status = this.$route.query.category;
        this.searchCategory.statusName = this.$route.query.categoryName;
        this.currentPage = parseInt(this.$route.query.page);
        this.itemPerPage = parseInt(this.$route.query.itemPerPage);
        const response = await this.$http.post(
          process.env.SEARCH_PRODUCT,
          {
            catalogStatus: this.searchStatus.status,
            catalogName: this.searchProductName.replace(this.spaceRegex, " "),
            catalogType: this.searchType.status,
            catalogCategory: this.searchCategory.status,
            page: this.currentPage,
            itemPerPage: this.itemPerPage,
          },
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        );
        if (response.data.status == 400) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          });
          // this.handleLogout();
        } else {
          if (this.currentPage > response.data.content.totalPage) {
            this.searchData(1);
          } else {
            this.dataCatalog = response.data.content.data;
            this.totalPage = response.data.content.totalPage;
            this.currentPage = response.data.content.currentPage;
            this.totalData = response.data.content.totalData;
            this.loadingTable = false;
          }
        }
      } catch (error) {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then((v) => {
          if (error.response.data.status == 401) {
            this.handleLogout();
          }
        });
      }
    },
    getProperty() {
      this.$http
        .get(process.env.GET_CATALOG_LIST_PROPERTY, {
          headers: {
            "Asani-Token": localStorage.getItem("jwt"),
          },
        })
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            });
            // this.handleLogout();
          } else {
            this.catalogPropertyType = response.data.content.catalogType;
            this.catalogPropertyCategory =
              response.data.content.catalogCategory;
          }
        })
        .catch((error) => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });
    },
    submitChangeStatus() {
      this.loadingButtonProcess = true;
      this.$http
        .post(
          process.env.CHANGE_CATALOG_STATUS,
          {
            catalogId: Number(this.selectedCatalog.catalogId),
            adminId: this.adminId,
          },
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        )
        .then((response) => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            });
            // this.handleLogout();
          } else if (response.data.status == 200) {
            swal("Success", response.data.message, "success", {
              button: "Ok",
            });
            $("#modalChange").modal("hide");
            // if (response.data.content.changeShowing == "yes") {
            //     this.sendLog(this.productIdChoose, 34);
            // }
            // if (response.data.content.changeStatus == 0) {
            //     this.sendLog(this.productIdChoose, 32);
            // }
            // if (response.data.content.changeStatus == 1) {
            //     console.log("masuk aktive");
            //     this.sendLog(this.productIdChoose, 33);
            // }
            this.getData();
            this.loadingButtonProcess = false;
          }
        })
        .catch((error) => {
          console.log(error.respose);
          swal("Sorry", error.message, "error", {
            button: "Ok",
          }).then((v) => {
            if (error.response.data.status == 401) {
              this.handleLogout();
            }
          });
        });
    },
    sendLog(x, y) {
      var today = new Date();
      var month = today.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var dateDay = today.getDate();
      if (dateDay < 10) {
        dateDay = "0" + dateDay;
      }
      var hours = today.getHours();
      if (hours < 10) {
        hours = "0" + hours;
      }
      var minutes = today.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      var second = today.getSeconds();
      if (second < 10) {
        second = "0" + second;
      }
      var date = today.getFullYear() + "-" + month + "-" + dateDay;
      var time = hours + ":" + minutes + ":" + second;
      var dateTime = date + " " + time;
      var admin = this.admin;
      var command = "add-logs";
      var productName =
        this.productNameChoose == null
          ? this.productNameChoose
          : this.productNameChoose.replace(this.spaceRegex, " ");
      if (y == "34") {
        var newShowing = this.showingChoose;
        this.$http
          .post(
            process.env.LOG_URL + "/product/" + x,
            {
              codeLogs: y,
              params: [productName, newShowing],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$http
          .post(
            process.env.LOG_URL + "/product/" + x,
            {
              codeLogs: y,
              params: [productName],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  async created() {
    this.admin = localStorage.getItem("admin_name");
    this.adminId = localStorage.getItem("admin_id");
    this.cekLogin();
    this.cekPermission();
    await this.getData();
    await this.getProperty();
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.text-main-color {
  color: #2E3646;
}

.default-btn {
  font-weight: 600;
  height: fit-content;
  font-size: .875rem;
  padding: .5rem .75rem;
  border-radius: .375rem;
}

.icon-btn {
  border-radius: 8px;
  padding: 4px;
  background: #ffffff;
  width: 34px;
}

.icon-btn-blue {
  border: 1px solid #247FEC66;
}

.icon-btn-orange {
  border: 1px solid #F2641966;
}

.icon-btn-red {
  border: 1px solid #FF344480;
}

.icon-btn-green {
  border: 1px solid #C8DFCA;
}

.reset-btn {
  border: 1px solid #D1D9E2;
  color: #2E3646;
}

.field-label {
  width: 160px;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797fb;
  color: #fff;
  border: 1px solid #2797fb;
}

.p8 a:hover {
  text-decoration: none;
}
.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797fb;
}

.total-data {
  font-size: 14px;
  color: #343a40;
}

.right-dropdown {
  margin-left: 7px;
}

.main-content-wrapper {
  padding: 1rem 4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalog/CatalogListPage.vue